import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";

// 쿠팡 사건 ID
export const LAWSUIT_ID = 2;

// 본인인증 단계의 약관 동의(개인정보/이용약관/마케팅)를 임시 저장하는 localStorage 키
export const TERMS_STORAGE_KEY = "termsAgreements";

/**
 * 약관 동의 정보를 서버에 반영합니다.
 * PATCH /applications/{id} (UpdateTermsDto)
 *
 * 신청서 생성(POST /applications) 이후 각 동의 단계에서 호출하며,
 * 항상 lawsuitId(=2)를 함께 전송합니다.
 *
 * @param {Object} fields - 업데이트할 동의 필드 (예: { hasAgreedToNotice: true })
 * @param {string|number} [applicationIdOverride] - application id 직접 지정 (없으면 쿠키에서 조회)
 * @returns {Promise<Object|null>} 성공 시 응답 데이터, 실패 시 null (예외를 던지지 않음)
 */
export const updateTermsAgreement = async (fields, applicationIdOverride) => {
  try {
    const applicationId =
      applicationIdOverride || Cookies.get("application_id");

    if (!applicationId) {
      console.warn(
        "[updateTermsAgreement] application_id가 없어 약관 동의 업데이트를 건너뜁니다."
      );
      return null;
    }

    const token = Cookies.get(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);

    const response = await fetch(
      `${API_ENDPOINTS.BASE_URL}/applications/${applicationId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          lawsuitId: LAWSUIT_ID,
          ...fields,
        }),
      }
    );

    if (!response.ok) {
      console.error(
        "[updateTermsAgreement] 약관 동의 업데이트 실패:",
        response.status
      );
      return null;
    }

    return await response.json().catch(() => null);
  } catch (error) {
    console.error("[updateTermsAgreement] 약관 동의 업데이트 오류:", error);
    return null;
  }
};
